export default __webpack_public_path__ + "static/media/illustration-health-2-m@2x.ccba25ff.webp";